<template>
  <a
    ref="link"
    :target="getTarget()"
    :href="href"
    @click="onLinkClick"
    :class="getClass()"
  >
    {{ label }}</a
  >
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import withNavigate from "@/mixins/withNavigate";

export default Vue.component("VLink", {
  props: {
    href: VueTypes.string.def("#"),
    type: VueTypes.oneOf([
      "primary",
      "secondary",
      "tertiary",
      "dark",
      "gray",
      "gray-underline",
      "danger"
    ]).def("primary"),
    label: VueTypes.string.isRequired,
    routerLink: VueTypes.string,
    blank: VueTypes.bool.def(false),
    extraClass: VueTypes.string
  },
  mixins: [withNavigate],
  methods: {
    onLinkClick(e) {
      e.preventDefault();
      e.stopPropagation();

      if (this.routerLink) {
        this.navigate(this.routerLink);
      } else {
        if (this.href) {
          this.blank
            ? this.externalBlank(this.href)
            : this.goToExternal(this.href);
        } else {
          this.$emit("click", e);
        }
      }
    },

    getClass() {
      return {
        [this.type]: true,
        [this.extraClass]: !!this.extraClass
      };
    },

    getTarget() {
      return this.blank ? "_blank" : "_self";
    }
  }
});
</script>

<style lang="scss" scoped>
@include mainColorPaletteClasses(1);
a {
  font-size: 15px;
  text-decoration: none;
}

.danger {
  color: $danger-color;
}
</style>
